import React from 'react';
import LocationsView from './views/LocationsView';
import { useLocations } from './hooks/Locations.hook';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';

const LocationsController = () => {
  const {
    loading,
    error,
    handleSubmit,
    popularNeighborhoods,
    handleClickLocation,
    locations,
    goToWorkspaceMap,
  } = useLocations();
  const languageData = useSelector(state => state.lenguage?.lang);
  const initialValues = {
    email: '',
    password: '',
    confirmPassword: '',
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Required'),
    password: Yup.string().min(6, 'Minimum 6 characters').required('Required'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Passwords must match')
      .required('Required'),
  });

  const onLocations = async values => {
    console.log('Simulated Locations with desinies:', values);
    window.location.href = '/dashboard';
  };

  return (
    <LocationsView
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={values => handleSubmit(values, onLocations)}
      loading={loading}
      error={error}
      languageData={languageData}
      popularNeighborhoods={popularNeighborhoods}
      locations={locations}
      goToWorkspaceMap={goToWorkspaceMap}
      handleClickLocation={handleClickLocation}
    />
  );
};

export default LocationsController;
